export const DEFAULT_STATE = {
  reloadcarrierData: {},
  reloadreportdownloadData: {},
  selectAllEmailReloadreportdownloadData: {},
  reloadEquipmentData: {},
  reloadDataSourceData: {}
};
